<template>
    <b-form-group :label="Title" :label-cols="statusInline">
        <!-- <span>{{ Title }} </span> -->
        <Select2
            v-model="models"
            :options="data"
            @change="changeSelected($event)"
            :settings="{ multiple: statusMultiple, width: width }"
            :placeholder="placeholder"
            :disabled="disabled"
        />
    </b-form-group>
</template>

<script>
export default {
    data() {
        return {
            selected: null,
            options: [],
            dataLogin: JSON.parse(localStorage.getItem('dataLogin')),
        };
    },
    props: {
        placeholder: String,
        changeSelected: Function,
        data: Array,
        Title: String,
        models: String,
        statusMultiple: Boolean,
        grup: Number,
        statusInline: {
            type: String,
            default: 'false',
        },
        width: {
            type: String,
            default: '100%',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    components: {},
    mounted() {},
    methods: {},
};
</script>
